module.exports = __webpack_public_path__ + "static/media/intro2.b1e3d057.mp4";